<template>
    <BreadCrumb PageTitle="Task List" />
    <TaskList />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import TaskList from "../../components/Task/TaskList.vue";
  
  export default defineComponent({
    name: "IntegrationsPage",
    components: {
      BreadCrumb,
      TaskList,
    },
  });
  </script>